import React from "react";

/**
 * Küçük, yuvarlak, gri zeminli seçim anahtarı (#454) — FilterTabs'tan BİLEREK
 * farklı görünür: liste üstünde tip sekmelerinin yanında ikinci bir durum
 * seçimi (ör. Tümü / Aktif / Pasif) sekmelerle karışmasın.
 *
 * @param {Array<{id, label, dot?}>} options  dot: nokta rengi sınıfı (bg-…)
 * @param {string} value
 * @param {Function} onChange (id)
 * @param {string} ariaLabel
 */
export default function SegmentedSwitch({ options = [], value, onChange, ariaLabel, className = "" }) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={`inline-flex items-center gap-0.5 p-0.5 rounded-full bg-gray-100 border border-gray-200 ${className}`}
    >
      {options.map((opt) => {
        const active = opt.id === value;
        return (
          <button
            key={opt.id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange?.(opt.id)}
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs whitespace-nowrap transition-colors ${
              active
                ? "bg-white text-gray-900 font-semibold shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {opt.dot && <span aria-hidden="true" className={`w-2 h-2 rounded-full ${opt.dot}`} />}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
